import { useState } from "react";

import LoadingSpinner from "../../images/loading_gray.gif";
import Modal from "../Modal/Modal";
import {
  Button,
  ButtonContainer,
  Container,
  TextArea,
  TextContainer,
} from "./RejectionCommentStyles";

const REJECTION_MAX_LENGTH = 124;
interface Props {
  toggleModal: () => void;
  title: string;
  onReject: (comment: any) => Promise<void>;
  hideSidebar?: () => void;
}
function RejectionComment(props: Props) {
  const { toggleModal, title, onReject, hideSidebar } = props;
  const [comment, updateComment] = useState("");
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);

  const onCommentChange = (ev) => {
    updateComment(ev.target.value);
  };

  const onClose = () => {
    if (toggleModal != null) {
      toggleModal();
    }
  };

  const isDisabled = comment === "";

  return (
    <Modal
      onOutsideClick={() => {
        onClose();
      }}
    >
      <Container>
        <h1>{title}</h1>
        <TextContainer>
          <h3>Motivo de rechazo</h3>
          <TextArea
            type="text"
            placeholder={"Escribe el motivo de rechazo"}
            onChange={onCommentChange}
            value={comment}
            maxLength={REJECTION_MAX_LENGTH}
          />
        </TextContainer>
        <ButtonContainer>
          <Button
            disabled={isDisabled || waitingForServerResponse}
            onClick={() => {
              if (waitingForServerResponse) return;
              updateWaitingForServerResponse(true);
              onReject(comment)
                .then(() => {
                  updateWaitingForServerResponse(false);
                  toggleModal();
                  hideSidebar();
                })
                .catch(() => updateWaitingForServerResponse(false));
            }}
          >
            {waitingForServerResponse && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            Guardar motivo de rechazo
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
}

export default RejectionComment;
